export default "__VITE_ASSET__CwWipap5__"